import React, { useState } from 'react';
import { FiMapPin, FiPhone, FiMail, FiClock, FiFacebook, FiInstagram, FiMessageCircle, FiGlobe } from 'react-icons/fi';
import { FaTelegramPlane } from 'react-icons/fa';
import { toast } from 'react-hot-toast';

const Contact = () => {
  useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      toast.success('សាររបស់អ្នកត្រូវបានផ្ញើដោយជោគជ័យ!');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setSubmitting(false);
    }, 1000);
  };

  const contactInfo = [
    {
      icon: FiMapPin,
      title: 'អាសយដ្ឋាន',
      details: [
        'ក្បែររង្វង់មូលទុរេន',
        'កំពត, កម្ពុជា'
      ]
    },
    {
      icon: FiPhone,
      title: 'ទូរស័ព្ទ',
      details: [
        
      ]
    },
    {
      icon: FiMail,
      title: 'អ៊ីមែល',
      details: ['naacollection@gmail.com']
    },
    {
      icon: FiClock,
      title: 'ម៉ោងបើក',
      details: [
        'ចន្ទ - អាទិត្យ: ៨:០០ ព្រឹក - ៩:០០ យប់',
        'បើករាល់ថ្ងៃ',
        <span key="open-status" className="text-green-600 font-medium">✓ បើកដំណើរការរាល់ថ្ងៃ</span>
      ]
    }
  ];

  const socialLinks = [
    { icon: FiFacebook, url: 'https://web.facebook.com/NAaCollection', label: 'Facebook', color: '#1877f2' },
    { icon: FiInstagram, url: 'https://instagram.com/naacollection', label: 'Instagram', color: '#e4405f' },
    { icon: FaTelegramPlane, url: 'https://t.me/nnick321', label: 'Telegram', color: '#0088cc' },
    { icon: FiMessageCircle, url: 'https://t.me/nnick321', label: 'Messenger', color: '#00b2ff' }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
          ទំនាក់ទំនង<span className="text-black">ពួកយើង</span>
        </h1>
        <p className="text-gray-600 text-sm max-w-2xl mx-auto">
          មានលក់សំលៀកបំពាក់បុរស និងនារី ទាន់សម័យ 🛍️👍🥰
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Contact Information */}
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {contactInfo.map((info, index) => {
              const Icon = info.icon;
              return (
                <div key={index} className="bg-white border border-gray-200 p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <Icon size={24} className="text-black" />
                    <h3 className="font-semibold text-gray-800">{info.title}</h3>
                  </div>
                  <div className="space-y-1">
                    {info.details.map((detail, i) => (
                      <div key={i}>
                        {typeof detail === 'string' ? (
                          <p className="text-gray-600 text-sm">{detail}</p>
                        ) : detail.type ? (
                          <p className="text-gray-600 text-sm">
                            {detail.number} <span className="text-gray-400">({detail.type})</span>
                          </p>
                        ) : (
                          detail
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Store Description */}
          <div className="mt-5 bg-white border border-gray-200 p-5">
            <h3 className="font-semibold text-gray-800 mb-2">NAa Collection</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              👖👗👠👜✨ ហាងលក់សំលៀកបំពាក់បុរស និងនារី ទាន់សម័យ 
              គុណភាពខ្ពស់ តម្លៃសមរម្យ។ សូមអញ្ជើញមកកាន់ហាងរបស់យើងខ្ញុំ 
              ដើម្បីជ្រើសរើសម៉ូដដែលអ្នកចូលចិត្ត!
            </p>
          </div>

          {/* Social Media */}
          <div className="mt-5 bg-white border border-gray-200 p-5">
            <h3 className="font-semibold text-gray-800 mb-3">តាមដានយើង</h3>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 border border-gray-200 text-gray-600 hover:bg-black hover:text-white hover:border-black transition-colors"
                    title={social.label}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Map - Kampot Location */}
          <div className="mt-5 border border-gray-200 overflow-hidden rounded-lg">
            <iframe
              title="NAa Collection Location - Kampot"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126908.72364317172!2d104.10793545!3d10.60921755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31088d2d276f9395%3A0x6a4bb7b73b6b4c5b!2sKampot%2C%20Cambodia!5e0!3m2!1sen!2skh!4v1700000000000!5m2!1sen!2skh"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full"
            />
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white border border-gray-200 p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            ផ្ញើ<span className="text-black">សារមកយើង</span>
          </h2>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                ឈ្មោះ <span className="text-black">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-black focus:bg-white transition-colors"
                placeholder="សូមបញ្ចូលឈ្មោះរបស់អ្នក"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                អ៊ីមែល <span className="text-black">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-black focus:bg-white transition-colors"
                placeholder="សូមបញ្ចូលអ៊ីមែលរបស់អ្នក"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                លេខទូរស័ព្ទ
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-black focus:bg-white transition-colors"
                placeholder="សូមបញ្ចូលលេខទូរស័ព្ទ"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                សារ <span className="text-black">*</span>
              </label>
              <textarea
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-black focus:bg-white transition-colors"
                placeholder="សូមបញ្ចូលសាររបស់អ្នក..."
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-black text-white py-3 font-medium text-sm hover:bg-gray-800 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {submitting ? 'កំពុងផ្ញើ...' : 'ផ្ញើសារ'}
            </button>
          </form>

          <div className="mt-5 pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500 text-center">
              យើងនឹងឆ្លើយតបទៅកាន់អ្នកក្នុងរយៈពេល ២៤ ម៉ោង
            </p>
          </div>
        </div>
      </div>

      {/* Quick Contact Bar */}
      <div className="mt-8 bg-gray-100 border border-gray-200 p-4 rounded-lg">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <FiPhone className="text-black" size={24} />
            <div>
              <p className="text-sm font-medium text-gray-800">ទូរស័ព្ទលឿន</p>
     
            </div>
          </div>
          <div className="flex items-center gap-3">
            <FaTelegramPlane className="text-black" size={24} />
            <div>
              <p className="text-sm font-medium text-gray-800">Telegram</p>
              <p className="text-sm text-gray-600">@nnick321</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <FiClock className="text-black" size={24} />
            <div>
              <p className="text-sm font-medium text-gray-800">ម៉ោងបើក</p>
              <p className="text-sm text-gray-600">ចន្ទ - អាទិត្យ ៨:០០ - ២១:០០</p>
              <p className="text-xs text-green-600">បើករាល់ថ្ងៃ</p>
            </div>
          </div>
        </div>
      </div>

      {/* Location Banner */}
      <div className="mt-6 text-center">
        <p className="text-gray-600 text-sm">
          📍 ទីតាំង: កំពត (ក្បែររង្វង់មូលទុរេន)
        </p>
        <div className="flex justify-center gap-1 mt-2 text-xl">
          👖 👗 👠 👜 ✨
        </div>
      </div>
    </div>
  );
};

export default Contact;